/**
 * queryClient.ts — TanStack Query 설정
 */

import { QueryClient } from '@tanstack/react-query'
import { apiFetch, getErrorMessage } from './api.js'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

/**
 * apiFetch를 감싸서 TanStack Query queryFn으로 사용.
 * 성공 시 data만 반환, 실패 시 Error throw.
 */
export async function apiQueryFn<T>(
  path: string,
  opts?: RequestInit & { skipAuth?: boolean }
): Promise<T> {
  const res = await apiFetch<T>(path, opts)
  if (res.success) return res.data
  throw new Error(getErrorMessage(res.error))
}
